module.exports = __webpack_public_path__ + "images/backgrounds/snow-bokeh/full.546c0382a582e8ea2695.jpg";